import React from 'react';
import { PlayIcon, PauseIcon, ChevronDownIcon, RewindIcon, FastForwardIcon } from 'lucide-react';
import { useAudioPlayer } from '../context/AudioPlayerContext';
export function ExpandedPlayer({
  onClose
}) {
  const {
    currentTrack,
    isPlaying,
    togglePlayPause,
    skipForward,
    skipBackward,
    currentTime,
    duration,
    setProgress
  } = useAudioPlayer();
  if (!currentTrack) return null;
  const progress = duration ? currentTime / duration * 100 : 0;
  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };
  const handleProgressChange = e => {
    const newProgress = parseFloat(e.target.value);
    setProgress(newProgress);
  };
  return <div className="h-full bg-white border-t flex flex-col" data-id="element-17">
      <div className="flex items-center p-4 border-b" data-id="element-18">
        <button className="p-2 hover:bg-gray-100 rounded-full" onClick={onClose} data-id="element-19">
          <ChevronDownIcon className="h-5 w-5 text-gray-600" data-id="element-20" />
        </button>
        <h3 className="text-lg font-semibold text-center flex-1" data-id="element-21">
          Now Playing
        </h3>
        <div className="w-9" data-id="element-22"></div> {/* Spacer for alignment */}
      </div>
      <div className="flex-1 overflow-auto p-6 flex flex-col md:flex-row gap-6" data-id="element-23">
        <div className="md:w-1/2" data-id="element-24">
          <div className="w-full h-64 md:h-96 bg-cover bg-center rounded-lg shadow-md" style={{
          backgroundImage: `url(${currentTrack.imageSrc})`
        }} data-id="element-25" />
          <div className="mt-6" data-id="element-26">
            <div className="flex justify-between text-sm text-gray-500" data-id="element-27">
              <span data-id="element-28">{formatTime(currentTime)}</span>
              <span data-id="element-29">{formatTime(duration)}</span>
            </div>
            <input type="range" min="0" max="100" value={progress} onChange={handleProgressChange} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-30" />
            <div className="flex justify-center items-center gap-4 mt-4" data-id="element-31">
              <button className="p-3 rounded-full hover:bg-gray-100" onClick={skipBackward} data-id="element-32">
                <RewindIcon className="h-6 w-6 text-gray-700" data-id="element-33" />
              </button>
              <button className="p-4 rounded-full bg-blue-500 text-white" onClick={togglePlayPause} data-id="element-34">
                {isPlaying ? <PauseIcon className="h-8 w-8" data-id="element-35" /> : <PlayIcon className="h-8 w-8" data-id="element-36" />}
              </button>
              <button className="p-3 rounded-full hover:bg-gray-100" onClick={skipForward} data-id="element-37">
                <FastForwardIcon className="h-6 w-6 text-gray-700" data-id="element-38" />
              </button>
            </div>
          </div>
        </div>
        <div className="md:w-1/2" data-id="element-39">
          <h2 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-40">
            {currentTrack.title}
          </h2>
          <p className="text-gray-500 mb-1" data-id="element-41">{currentTrack.subtitle}</p>
          <p className="text-gray-700 mb-4" data-id="element-42">
            Speaker: <span className="font-medium" data-id="element-43">{currentTrack.speaker}</span>
          </p>
          <div className="bg-gray-50 p-4 rounded-lg" data-id="element-44">
            <h3 className="font-medium text-gray-700 mb-2" data-id="element-45">Transcript</h3>
            <div className="text-gray-600 space-y-2" data-id="element-46">
              {currentTrack.transcript}
            </div>
          </div>
        </div>
      </div>
    </div>;
}